import { render, staticRenderFns } from "./OnboardingStepsLayout.vue?vue&type=template&id=24138aba&lang=pug"
import script from "./OnboardingStepsLayout.vue?vue&type=script&lang=js"
export * from "./OnboardingStepsLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports